import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";

const JobieNav = () => {
	const [toggle, setToggle] = useState(false);
	return (
		<Fragment>
			<NavHader setToggle={setToggle} toggle={toggle} />
			<SideBar setToggle={setToggle} toggle={toggle} />
			<Header />
		</Fragment>
	);
};

export default JobieNav;
